import { useState, useEffect, useContext, useRef } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-modal'
import axios from 'axios'
import axio from 'axios'
import Loading from './Loading'
import { projectContext, loadingContext, unfolder, onImportExcelAsync, useTranslate } from '../lib'
import { urlValue } from '../lib'
import '../styles/styles.css'
import '../styles/newProjectModal.scss'
import { customModal } from '../styles/customModal'
import AWS from 'aws-sdk'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import ButtonYesNo from './common/ButtonYesNo'
import BoxInfo from './common/BoxInfo'
import { InputNesting } from './common/Inputs/Input'
import { SelectNesting } from './common/Inputs/Select'
import Swal from 'sweetalert2'
import { CustomChat } from './CustomChat'

export default function NewProjectView({ isModalOpen, closeModal, onClose }) {
  const [loading, setLoading] = useContext(loadingContext)
  const [campaings, setCampaings] = useState([])
  const [voices, setVoices] = useState([])
  const [radomVoice, setRadomVoice] = useState(false)
  const [listLanguage, setListLanguage] = useState([])
  const [ProjectExcel, setProjectExcel] = useState([])
  const [loadingUpload, setLoadingUpload] = useState(false)
  const [subCampaings, setSubCampaings] = useState([])
  const [useDefaultSentiment, setUseDefaultSentiment] = useState(0);
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [hold, setHold] = useState(true)
  const [nlp_configName, setNlp_configName] = useState("Upload");
  const [imageName, setImageName] = useState("Upload");
  const [image, setImage] = useState(null);
  const [nlp_config, setNlp_config] = useState(null);
  const [error, setError] = useState({ name: "" })
  const [channel, setChannel] = useState("voice")
  const [category, setCategory] = useState('outbound');
  const [transcription, setTranscription] = useState(0);
  const [simulationStatus, setSimulationStatus] = useState(0);
  const [assistedSimulation, setAssistedSimulation] = useState(0);
  const [azureScenario, setAzureScenario] = useState(0);
  const [customChats, setCustomChats] = useState([
    { id: 0, name: 'Standard' },
    { id: 1, name: 'WhatsApp' },
    { id: 2, name: 'Telegram' },
  ]);
  const [selectedChatOption, setSelectedChatOption] = useState(0);
  const [showCustomChatForm, setShowCustomChatForm] = useState(false);
  const { t } = useTranslate();
  const timeHoldRef = useRef();
  const minimunCallDurations = useRef();
  const maxUserResponseTime = useRef();
  const timeHoldAmountRef = useRef();
  const language = useRef();
  const campaingRef = useRef()
  const subCampaingRef = useRef()
  const affectation_time_ref = useRef();
  const percentage_affectation_ref = useRef();
  const bot_respose_time_ref = useRef();
  const Simulation_Step_number_ref = useRef();
  const minimum_passing_score_ref = useRef();
  
  const fileString = ''
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const fetchCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    try {
      const url = `${urlValue}/studio/project/camp/campaing`;
      const rest = await axio.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setCampaings(rest.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchVoice = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/project/voices/all`;
      const rest = await axio.get(url, {
        headers: {
          user: id,
          language: language?.current?.value.substring(0, 2)  || 'EN',
          'access-token': token,
          'Content-Type': 'application/json',
          'project_id': 0
        },
      });
      
      if (rest.status === 200 && rest.data) {
        setVoices(rest.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchSubCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    try {
      const url = `${urlValue}/studio/project/camp/sub-campaing`;
      const rest = await axio.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setSubCampaings(rest.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchLanguage = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/language`;
      const rest = await axio.get(url, {
        headers: {
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setListLanguage(rest.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchCustomChats = async () => {
    const predefined = [
      { id: 0, name: 'Standard' },
      { id: 1, name: 'WhatsApp' },
      { id: 2, name: 'Telegram' },
    ];
    
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    
    try {
      const url = `${urlValue}/studio/project/customchats/all`;
      
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
          'project_id': 0
        },
      });
  
      if (rest.status === 200 && rest.data.data) {
        setCustomChats([...predefined, ...rest.data.data])
      }
      return rest.data.data;
    } catch (error) {
      setCustomChats(predefined)
      console.log(error)
      return error;
    }
  };

  useEffect(() => {
    fetchCampaing();
    fetchSubCampaing();
    fetchLanguage();
    fetchVoice();
    fetchCustomChats();
  }, [])

  const convertToBase64 = (file) => {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      }
    })
  }

  const onSubmit = async data => {

    let ok = true
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken

    if (!nlp_config) {
      setError({ ...error, name: t('errors.jsonRequired') });
      ok = false;
      Swal.fire({
        title: t('menu.actionRequired'),
        text: t('alerts.uploadDialogFlow'),
        icon: 'warning',
        confirmButtonText: t('common.ok'),
        confirmButtonColor: '#3085d6'
      });
      return;
    }

    try {
      const nlp_config_file_url = URL.createObjectURL(nlp_config);
      const getJson = await fetch(nlp_config_file_url);
      const json_nlp_text = await getJson.text();

      let json_nlp;

      try {
        json_nlp = JSON.parse(json_nlp_text);
      } catch (parseError) {
        setError({ ...error, name: t('errors.jsonNotValid') });
        Swal.fire({
          title: t('alerts.invalidFile'),
          text: t('alerts.jsonInvalidFile'),
          icon: 'error',
          confirmButtonText: t('common.ok'),
          confirmButtonColor: '#3085d6'
        });
        return;
      }

      if (!json_nlp.hasOwnProperty("type")) {
        setError({ ...error, name: t('alerts.jsonInvalidStructure') });
        Swal.fire({
          title: t('alerts.invalidFileStructure'),
          text: t('alerts.jsonInvalidStructure'),
          icon: 'error',
          confirmButtonText: t('common.ok'),
          confirmButtonColor: '#3085d6'
        });
        ok = false;
        return;
      }

      const exp = /^[A-Za-z0-9-,._'¿?\s]+$/g;
      if (!exp.test(data.name)) {
        ok = false;
        setError({ ...error, name: t('errors.nameInvalid') })
      }

      if (ok) {
        let convertedFile = ""
        if (image) {
          convertedFile = await convertToBase64(image)
        }

        const dataSend = {
          name: data.name,
          //Se cambio a null temporalmente hasta la primera entrega despues agregar id de cada nlp Dlowflow RASA
          nlp: 1,
          nlp_config: json_nlp,
          nlp_url: 'localhost',
          metadata: { "description": data.metadata, "language": language?.current?.value || 'EN-US'  },
          //Se cambio a null temporalmente hasta la primera entrega despues /agregar la imagen
          image: { "imageName": imageName, "url": "" } || null,
          imageFile: convertedFile || null,
          time_hold_amount: timeHoldAmountRef.current?.value || 0,
          time_hold_seconds: timeHoldRef.current?.value || 0,
          use_hold: hold ? 1 : 0,
          campaing: campaingRef.current?.value,
          sub_campaing: subCampaingRef.current?.value,
          url_tp_simulation: data.url_tp_simulation,
          voice: document.querySelector("#voice")?.value,
          random_voice: radomVoice ? 1 : 0,
          use_default_sentiment: useDefaultSentiment,
          channel: channel,
          gender_bot_avatar: document.getElementById('gender_bot_avatar')?.value,
          transcription: transcription,
          min_call_time: minimunCallDurations.current?.value || 0,
          max_user_response_time: maxUserResponseTime.current?.value || 0,
          bot_response_time: bot_respose_time_ref.current?.value || 0,
          simulation_status: simulationStatus,
          num_simulation_steps: Simulation_Step_number_ref.current?.value || 0,
          assisted_simulation: assistedSimulation,
          azure_scenario: azureScenario,
          custom_chat: selectedChatOption,
          minimum_passing_score: minimum_passing_score_ref.current?.value || 70,
        }
        console.log('dataSend', dataSend)
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

        axios({
          method: 'post',
          url: `${urlValue}/studio/project`,
          headers: {
            user: id,
            'access-token': token,
            'X-CSRF-Token': csrfToken
          },
          withCredentials: true,
          data: dataSend,
          // data: formDataImage
        })
          .then(function (response) {
            onClose()
            setLoading(false)
            window.location.reload();
          })
          .catch(function (error) {
            onClose()
            setLoading(false)
          })
        }
      } catch (error) {
        Swal.fire({
          title: t('common.error'),
          text: t('errors.errorJson'),
          icon: 'error',
          confirmButtonText: t('common.ok'),
          confirmButtonColor: '#3085d6'
        });
        return;
      }

    
  }

  const uploadMaxive = async () => {

    if (!loadingUpload && ProjectExcel.length > 0 && ProjectExcel.length <= 51) {

      setLoadingUpload(true)
      setTimeout(async () => {

        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
        for (var i = 0; i < ProjectExcel.length; i++) {
          const dataSend = {
            name: ProjectExcel[i].Name?.trim(),
            //Se cambio a null temporalmente hasta la primera entrega despues agregar id de cada nlp Dlowflow RASA
            nlp: 1,
            nlp_config: JSON.parse(ProjectExcel[i].Motor_Congnitivo),
            nlp_url: 'localhost',
            metadata: { "description": ProjectExcel[i].Description, "language": ProjectExcel[i].Language },
            //Se cambio a null temporalmente hasta la primera entrega despues /agregar la imagen
            image: null,
            time_hold_amount: ProjectExcel[i].Hold_Attempts_per_call || 0,
            time_hold_seconds: ProjectExcel[i].Hold_Time_Seconds || 0,
            use_hold: ProjectExcel[i].Use_hold_time === 1 ? 1 : 0,
            campaing: ProjectExcel[i].Campaign,
            sub_campaing: ProjectExcel[i].SubCampaign

          }

          const rest = await axios.post(`${urlValue}/studio/project`, dataSend, {
            headers: {
              user: id,
              'access-token': token,
              'X-CSRF-Token': csrfToken
            },
            withCredentials: true,
          })
        }
        setLoadingUpload(false);
        window.location.reload();
      }, 1000)

    } else {
      alert(t('alerts.projectExcelLimit'))
    }

  }
  const prepareExcel = async (e) => {
    const DatosExcel = await onImportExcelAsync(e);
    setProjectExcel(DatosExcel)
  }

  const ChangeModelSentiment = (e) => {
    if (e.target.value === 'Voice') {
      selectedProject.bot_sentiment = 0;
    }
  }

  const saveBotSentimentConfig = function (e) {

    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken

    axios({
      method: 'post',
      url: `${urlValue}/studio/project/${selectedProject.id}/bot_sentiment`,
      headers: {
        user: id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        bot_sentiment: e.target.value,
      }
    }).then(function (res) {
    }).catch(error => {
      console.log('Error to try update bot sentiment: ', error);
    })
  }

  const onChangeStatusSimulation = () => {
    setSimulationStatus((prev) => prev === 0 ? 1 : 0);
    if (simulationStatus === 1) {
      setAssistedSimulation(0);
    }
  }

  return (

    <div className="newProject-modal modal-cont ">
      <h1>{t('menu.createProject')}</h1>
      <form onSubmit={handleSubmit(onSubmit)} className="w-100">
        <div className="scroll-internal-modal sm7-h-50vh sm6-h-50vh sm5-h-70vh sm4-h-70vh sm3-h-70vh h-80 " >
          <div className="d-flex flex-row justify-space-between  "  >
            <div className="d-flex flex-column" style={{ width: '45%' }}>
              <div className="inputs" id="name">
                <div className="input tooltip">
                  <span>{t('common.name')}:</span>
                  <input placeholder={t('menu.newProjectName')} className='input-data' id='name' {...register('name', { required: true })} type="text" />
                  <Tooltip anchorId="name" content={t('alerts.charactersNameTooltip')} place="top" />
                  {/* <span className="tooltiptext"><div className='triangulo'></div></span> */}
                </div>
              </div>
              <div className="inputs" style={{ marginTop: 20 }} id="image">
                <div className="input">
                  <div className="flex items-center">
                    <span>{t('common.image')}</span>
                    <img id="image-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#image-tp" content={t('menu.genai.projectLogoTooltip')} place="top" />
                  </div>
                  <label className="custom-file">
                    <input
                      onChange={(e) => {
                        const file = e.target.files[0];
                    
                        if (file && file.type.startsWith('image/')) {
                          setImage(e.target.files[0]);
                          setImageName(e.target.files[0].name);
                        } else {
                          alert(t('alerts.validImage'));
                          e.target.value = null; // limpia el input
                        }
                      }}
                      // onChange={e => fileUploadHandler(e)}
                      type="file"
                      accept="image/png, .jpeg, .jpg"
                    />
                    {imageName}
                  </label>
                </div>
              </div>
              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input">
                  <span>{t('common.description')}</span>
                  <textarea placeholder={t('menu.genai.detailedDescriptionPlaceholder')} rows={3} {...register('metadata', { required: true })} />
                </div>
              </div>
              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input" id="welcoming_message">
                  <span>{t('menu.genai.outboundCallMessage')}</span>
                  <textarea placeholder={t('menu.genai.outboundCallMessageTooltip')} className='' rows={3} {...register('welcoming_message', { required: false })} />
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 25 }}>
                <div className="input d-flex flex-row align-items-center" style={{ alignItems: "center", flexDirection: "row" }}>
                  <div className="flex items-center">
                    <span>{t('menu.genai.botType')}:</span>
                    <img id="bottype-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-5 cursor-pointer tooltip-nesting  " alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#bottype-tp" content={t('menu.genai.inboundOuntboundTooltip')}place="top" />
                  </div>
                  <div className="ml-2 list_bot_type d-flex flex-row align-items-center" >
                    <ButtonYesNo
                      onClick={() => setChannel((prev) => prev === "voice" ? "chat" : "voice")}
                      width={170}
                      state={channel === "chat" ? false : true}
                      height={30}
                      Yes={t('menu.voiceBot')}
                      No={t('menu.chatBot')}
                    />
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20 }} >
                <div className="input d-flex flex-row align-items-center" style={{ alignItems: "center", flexDirection: "row" }}>
                  <span>{t('menu.genai.interactionType')}:</span>
                  <div className="list_call_type ml-2 d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setCategory((prev) => prev === "outbound" ? "inbound" : "outbound")}
                      width={170}
                      state={category === "outbound" ? false : true}
                      height={30}
                      Yes={t('common.inbound')}
                      No={t('common.outbound')}
                    />
                  </div>
                </div>
              </div>

              {channel === 'voice' &&
                <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input d-flex flex-row align-items-center" style={{ alignItems: "center", flexDirection: "row" }}>
                  <span>{t('menu.genai.transcriptionEnable')}:</span>
                  <img id="transcriptionenable-tp" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting  " alt="" />
                  <Tooltip openOnClick={true} anchorSelect="#transcriptionenable-tp" content={t('menu.genai.transcriptionEnableTooltip')} place="top" />	
                  <div className="list_transcription_enable ml-2 d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setTranscription((prev) => prev === 0 ? 1 : 0)}
                      width={140}
                      state={transcription === 0 ? false : true}
                      height={30}
                    />
                  </div>
                </div>
              </div>
              }
              


              <div style={{ marginTop: 20 }} className="inputs">
                <div className="input">
                  <div className="flex items-center">
                    <span>{t('menu.uploadDialogflow')}:</span>
                    <img id="upload-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#upload-tp" content={t('menu.uploadDialogFlowTooltip')} place="top" />
                  </div>
                  <label className="custom-file">
                    <input
                      onChange={(e) => { setNlp_config(e.target.files[0]); setNlp_configName(e.target.files[0].name) }}
                      type="file"
                      accept=".json"
                    />
                    {nlp_configName}
                  </label>
                </div>
              </div>



              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input " id="selectbox">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100">
                    <span>{t('common.campaign')}:</span>
                    <select ref={campaingRef} className='select ml-3 select-nesting input-data'
                      onChange={(e) => { }} style={{ flexGrow: '2', backgroundPositionX: "96%", height:"100%" }}>
                        <option disabled selected>
                          {t('menu.selectCampaign')}
                        </option>
                      {campaings.map((item, i) => (
                        <option value={item.id} key={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input " id="selectbox">
                  <div className="d-flex flex-row align-items-center justify-space-between w-100">
                    <span>{t('common.subCampaign')}:</span>
                    <select ref={subCampaingRef} className='select ml-3 select-nesting input-data ' style={{ flexGrow: '2', backgroundPositionX: "96%", height:"100%" }} onChange={(e) => { }}>
                      <option disabled selected>
                        {t('menu.selectSubcampaign')}
                        </option>
                      {subCampaings.map((item, i) => (
                        <option value={item.id} key={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

            </div>

            <div style={{ borderRight: '1px solid #bfbfbf' }}></div>

            <div className="d-flex flex-column" style={{ width: '45%', paddingRight: 20 }}>


            <div className="inputs" style={{ marginTop: 20 }}>
                {/*<SelectNesting
                  ref={language} id="language"
                  boxInfo={true} tooltipText="Select language for project"
                  title="Language:" containerClass=""
                  onChange={(e) => { fetchVoice() }} style={{fontWeight: '400', maxWidth: 180}}
                >  
                  {listLanguage.map((item, index) => (<option key={index} value={item.value}>{item.name}</option>))}
                </SelectNesting>*/}
                <div className="input" style={{maxWidth: 200}}>
                  <div className="d-flex flex-row align-items-center w-100">
                    <span>{t('common.language')}:</span>
                    <img id="language" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#language" textColor="#ffffff"
                        html={t('menu.genai.languageForProjectTooltip')} place="top" />
                    <select ref={language} onChange={(e) => { fetchVoice() }} className='select ml-3 select-nesting input-data ' 
                      style={{ flexGrow: '2' }}>
                        {listLanguage.map((item, index) => (<option key={index} value={item.value}>{item.name}</option>))}
                    </select>
                  </div>
                </div>
                
              </div>

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input">
                  <div className="d-flex flex-row align-items-center w-100">
                    <span>{t('menu.genai.botSentiment')}:</span>
                    <img id="bot-sentiment-span" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#bot-sentiment-span" textColor="#ffffff"
                      html={t('menu.genai.botSentimentTooltip')} place="top" />
                    <select onChange={saveBotSentimentConfig} className='select ml-3 select-nesting input-data ' 
                      style={{ flexGrow: '2', backgroundPositionX: "96%", maxWidth: 80 }}>
                      <option value="1" selected={selectedProject.bot_sentiment !== 0 ? 'selected' : ''}>{t('common.on')}</option>
                      <option value="0" selected={selectedProject.bot_sentiment === 0 ? 'selected' : ''}>{t('common.off')}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 20 }}>
                <div className="input">
                  <div className="d-flex flex-row align-items-center w-100">
                    <span>{t('menu.genai.modelSentiment')}:</span>
                    <img id="model-sentiment-span" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#model-sentiment-span" textColor="#ffffff"
                      html={t('menu.genai.modelSentimentTooltip')} place="top" />
                    <select onChange={ChangeModelSentiment} className='select ml-3 select-nesting input-data ' 
                      style={{ flexGrow: '2', backgroundPositionX: "96%", maxWidth: 100 }}>
                      <option value="Phrase" selected={selectedProject.model_sentiment ? 'selected' : ''}>{t('common.phrase')}</option>
                      <option value="Voice" selected={!selectedProject.model_sentiment ? 'selected' : ''}>{t('common.voice')}</option>
                      <option value="Answer" selected={!selectedProject.model_sentiment ? 'selected' : ''}>{t('common.answer')}</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* <div className="inputs" style={{marginTop: 20}}>
                <div className="input">
                  <div className='d-flex flex-row align-items-center w-100'>
                    <span style={{minWidth: 138}}>{t('menu.genai.onHoldAvailability')}:</span>
                    <input
                         
                        defaultChecked={hold}
                        onChange={(e) => { setHold(!hold); }}
                        type="checkbox"
                        style={{marginLeft: 10, width: 'auto'}}
                    />
                  </div>
                </div>
              </div> */}

              <div className="d-flex flex-col  ">
                {channel === 'voice' &&
                  <div className="inputs" style={{ marginTop: 20 }}  >
                    <div className="input">
                      <div className='d-flex flex-column  '  >
                        <span>{t('menu.genai.minimunCallDurations')}:</span>
                        <input style={{ maxWidth: 100 }}
                          ref={minimunCallDurations}
                          className='  mt-1 input-data'
                          disabled={!hold}
                          type="number"
                        />
                      </div>
                    </div>
                  </div>
                }
                {channel === 'chat' &&
                <div className="inputs" style={{ marginTop: 20 }}  >
                  <div className="input">
                    <div className='d-flex flex-column  '  >
                      <span>{t('menu.genai.maxCallDurations')}</span>
                      <input style={{ maxWidth: 113 }}
                        ref={maxUserResponseTime}
                        className=' mt-1 input-data'
                        disabled={!hold}
                        type="number"
                      />
                    </div>
                  </div>
                </div>
                }
              </div>
              {channel === 'voice' &&
                <div className="input">
                  <div className='d-flex flex-col mt-5  w-100'>
                    <div className="flex items-center " style={{ marginBottom: "2%" }}>
                      <span style={{}}>{t('menu.genai.onHoldAvailability')}:</span>
                      <img id="hold-tp" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                      <Tooltip openOnClick={true} anchorSelect="#hold-tp" 
                        html={t('menu.genai.onHoldAvailabilityTooltip')} place="top" />
                    </div>
                    <ButtonYesNo
                      onClick={() => setHold((prev) => !prev)}
                      width={140}
                      state={hold}
                      height={30}
                    />
                  </div>
                </div>
              }

              <div className="d-flex flex-column">
                {channel === 'voice' &&
                  <div className="inputs" style={{ marginTop: 23 }}  >
                    <div className="input">
                      <div className='d-flex flex-column'  >
                        <div className='d-flex flex-row align-items-center'>
                          <span>{t('menu.genai.holdTime')}:</span>
                          <img id="hold-time" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                          <Tooltip openOnClick={true} anchorSelect="#hold-time" 
                          html={t('menu.genai.holdTimeTooltip')} place="top" />
                        </div>
                        <input style={{ maxWidth: 113 }}
                          ref={timeHoldRef}
                          className='mt-3 input-data'
                          disabled={!hold}
                          type="number"
                        />
                      </div>
                    </div>
                  </div>
                }

                {channel === 'voice' &&
                  <div className="inputs" style={{ marginTop: 23 }}>
                    <div className="input">
                      <div className='d-flex flex-column w-100'>
                        <span style={{ marginRight: 50 }}>{t('menu.genai.holdAttempts')}:</span>
                        <div className="d-flex flex-row align-items-center mt-2">
                          <input style={{ maxWidth: 113 }}
                            ref={timeHoldAmountRef}
                            className='mt-3 input-data'
                            disabled={!hold}
                            type="number"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                }   

              </div>

              {/* <div className="inputs" style={{ marginTop: 20 }}>
              <div className="input">
                <div className='d-flex flex-row align-items-center w-100'>
                  <span style={{ minWidth: 138 }}>{t('menu.genai.randomVoices')}?</span>
                  <input
                    style={{ marginLeft: 10, width: 'auto' }}
                    defaultChecked={selectedProject.random_voice}
                    onChange={(e) => { setRadomVoice(!radomVoice); }}
                    type="checkbox"
                  />
                </div>
              </div>
            </div> */}
              {channel === 'chat' &&
                <div className="inputs" style={{ marginTop: 20 }}  >
                  <div className="input">
                    <div className='d-flex flex-row align-items-center'>
                      <div className='d-flex flex-row align-items-center'>
                        <span>{t('menu.genai.resolutionTime')}:</span>
                        <img id="resolution-time" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                        <Tooltip openOnClick={true} anchorSelect="#resolution-time" 
                          html={t('menu.genai.resolutionTimeTooltip')} place="top" />
                      </div>
                      <input style={{ maxWidth: 113 }}
                        ref={affectation_time_ref}
                        className='ml-3   input-data'
                        type="number"
                      />
                    </div>
                  </div>
                </div>
              }  
              {channel === 'chat' &&
                <div className="inputs" style={{ marginTop: 20 }}  >
                  <div className="input">
                    <div className='d-flex flex-row align-items-center'>
                      <div className='d-flex flex-row align-items-center'>
                        <span>{t('menu.genai.percentageOfAffectation')}:</span>
                        <img id="percentage-affectation" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                        <Tooltip openOnClick={true} anchorSelect="#percentage-affectation" 
                          html={t('menu.genai.precentageOfAffectationTooltip')} place="top" />
                      </div>
                      <input style={{ maxWidth: 113 }}
                        ref={percentage_affectation_ref}
                        className='ml-3 input-data'
                        type="number"
                      />
                    </div>
                  </div>
                </div>
              }

              {channel === 'chat' &&
                <div className="inputs" style={{ marginTop: 20 }}  >
                  <div className="input">
                    <div className='d-flex flex-row align-items-center'>
                      <div className='d-flex flex-row align-items-center'>
                        <span>{t('menu.genai.replyTime')}:</span>
                        <img id="reply-time" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                        <Tooltip openOnClick={true} anchorSelect="#reply-time" 
                          html={t('menu.genai.replyTimeTooltip')} place="top" />
                      </div>
                      <input style={{ maxWidth: 113 }}
                        ref={bot_respose_time_ref}
                        className='ml-3 input-data'
                        type="number"
                      />
                    </div>
                  </div>
                </div>
              }
              {channel === 'voice' &&
                <div className="inputs" style={{ marginTop: 20 }}>
                  <div className="input">
                    <div className='d-flex flex-col  w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>
                      <div className='d-flex flex-row align-items-center'>
                        <span>{t('menu.genai.randomVoices')}:</span>
                        <img id="random-voices" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                        <Tooltip openOnClick={true} anchorSelect="#random-voices" 
                          html={t('menu.genai.randomVoicesTooltip')} place="top" />
                      </div>
                      <ButtonYesNo
                        onClick={() => setRadomVoice((prev) => !prev)}
                        width={150}
                        state={radomVoice}
                        height={30}
                      />
                    </div>
                  </div>
                </div>
              }
              {channel === 'voice' &&
                <div className="inputs" style={{ marginTop: 20 }}>
                  <div className="input">
                    <div className="d-flex flex-row align-items-center justify-space-between w-100" >
                      <div className='d-flex flex-row align-items-center'>
                        <span>{t('menu.genai.selectVoice')}:</span>
                        <img id="select-voice" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                        <Tooltip openOnClick={true} anchorSelect="#select-voice" 
                          html={t('menu.genai.selectVoiceTooltip')} place="top" />
                      </div>
                      <select className='select ml-2 select-nesting input-data ' style={{ flexGrow: '2', backgroundPositionX: "96%" }} id="voice">
                        <option disabled selected>{t('menu.genai.selectVoiceOption')}</option>
                        {voices.map((item, index) => (
                          <option key={index} value={item.id}>{item.voice}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              }

              <div className="inputs" style={{ marginTop: 25 }}>
                <div className="input d-flex flex-row align-items-center" style={{ alignItems: "center", flexDirection: "row" }}>
                  
                  <div className='d-flex flex-row align-items-center'>
                    <span>{t('menu.defaultForSentiment')}:</span>
                    <img id="default-sentiment" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting  " alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#default-sentiment" 
                      html={t('menu.defaultForSentimentTooltip')} place="top" />
                  </div>
                  <div className="list_use_default_sentiment ml-2 d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setUseDefaultSentiment((prev) => prev === 0 ? 1 : 0)}
                      width={150}
                      state={useDefaultSentiment === 0 ? false : true}
                      height={30}
                    />
                  </div>
                </div>
              </div>

              <div className="inputs" style={{ marginTop: 25 }}>
                <div className="input d-flex flex-row align-items-center" style={{ alignItems: "center", flexDirection: "row" }}>
                  <span>{t('menu.genderAvatar')}:</span>
                  <select id="gender_bot_avatar" name='gender_bot_avatar' className="w-100 select-nesting input-data"
                    style={{ minWidth: 100, maxWidth: 80, padding: 8 }}>
                    <option value="male">{t('common.male')}</option>
                    <option value="female">{t('common.female')}</option>
                  </select>
                </div>
              </div>

              {channel === 'chat' && (
              <div className="inputs" style={{ marginRight: 20, marginTop: 25 }}>
                <div className="input">
                  <div className="d-flex flex-row align-center">
                    <span>{t('menu.genai.customChat')}:</span>
                    <img id="custom-chat" src="/icons/tooltip-indicator-icon.svg" className="ml-2 cursor-pointer tooltip-nesting" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#custom-chat" 
                      html={t('menu.genai.customChatTooltip')} place="top" />
                    <div style={{ maxWidth: 200, minWidth: 100 }}>
                      <select
                        className='w-100 select-nesting input-data'
                        style={{ flexGrow: '2', backgroundPositionX: "96%" }}
                        id="custom_chat"
                        onChange={(e) => {
                          const value = e.target.value;
                          setSelectedChatOption(value === 'new' || value === '' ? '' : value);
                          setShowCustomChatForm(value === 'new');
                        }}
                      >
                        {customChats.map((item) => (
                          <option value={item.id} key={item.id}>{item.name}</option>
                        ))}
                        <option value="new">{t('common.new')}</option>
                      </select>
                    </div>
                  </div>
                </div>

                {showCustomChatForm && (
                  <CustomChat update={() => { fetchCustomChats() }} />
                )}
              </div>
              )}

            </div>

          </div>


          <div className="d-flex flex-row flex-wrap" style={{margin: '40px 0 0 0', borderTop: '1px solid rgb(172 172 172)', padding: '15px 0 0 0'}}>
            <div className='d-flex flex-row mt-3 mb-3' style={{alignItems: 'center', width: '100%'}}>
              <h2 className="" style={{ color: '#1C6FB0', fontSize: 16, fontWeight: 'bold' }}>
                {t('menu.genai.simulationStatus')}:
              </h2>
              <div style={{marginLeft: 20}}>
                <ButtonYesNo
                  onClick={() => onChangeStatusSimulation()}
                  width={150}
                  state={simulationStatus === 0 ? false : simulationStatus}
                  height={30}
                  Yes={t('common.yes')}
                  No={t('common.no')}
                />
              </div>
            </div>

            <div className="inputs w-100 pr-2 mb-5 mt-2">
              <div className="input d-flex" style={{alignItems: 'center', flexDirection: 'row'}}>
                <span>{t('menu.genai.urlSimulation')}:</span>
                <input className='input-data' placeholder={t('menu.genai.urlSimulationPlaceholder')} 
                  {...register('url_tp_simulation', { required: false })} type="text" />
              </div>
            </div>

            
            
            <div className="inputs" style={{ marginRight: 30 }}>
              <div className="input d-flex items-center " style={{ height: "auto", flexDirection: 'row' }}>
                <span>{t('menu.genai.simulationStepNumber')}:</span>
                <img id="simulation-steps" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting" alt="" />
                <Tooltip openOnClick={true} anchorSelect="#simulation-steps" 
                  html={t('menu.genai.simulationStepNumberTooltip')} place="top" />
                <input {...register('num_simulation_steps', { required: false })} disabled={!simulationStatus}
                  ref={Simulation_Step_number_ref} id="Simulation_Step_number_ref" style={{maxWidth: 90}}
                  type="text" className={`input-text input-data ${!simulationStatus ? 'disabled' : ''}`}
                />
              </div>
            </div>

            <div className="inputs" style={{ marginRight: 30 }}>
              <div className="input d-flex align-items-center" style={{ flexDirection: 'row' }}>
                <span>{t('menu.genai.assistedSimulation')}:</span>
                <img id="assisted-simulation" src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting" alt="" />
                <Tooltip openOnClick={true} anchorSelect="#assisted-simulation" 
                  html={t('menu.genai.assistedSimulationTooltip')} place="top" />
                <div className="list_bot_type d-flex flex-row align-items-center">
                  <ButtonYesNo
                    onClick={() => setAssistedSimulation((prev) => prev === 0 ? 1 : 0)}
                    width={150}
                    state={assistedSimulation}
                    height={30}
                    Yes={t('common.yes')}
                    No={t('common.no')}
                    disabled={!simulationStatus}
                  />
                </div>
              </div>
            </div>

            <div className='d-flex flex-row flex-wrap align-center'>
              {/*<div className="inputs" style={{ marginRight: 30 }}>
                <div className="input d-flex align-items-center" style={{flexDirection: 'row'}}>
                  <span>Azure Scenario:</span>
                  <img id="azure-scenario" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                  <Tooltip openOnClick={true} anchorSelect="#azure-scenario" 
                    html={`Enable Azure scenario integration`} place="top" />
                  <div className="list_bot_type d-flex flex-row align-items-center">
                    <ButtonYesNo
                      onClick={() => setAzureScenario((prev) => prev === 0 ? 1 : 0)}
                      width={150}
                      state={azureScenario}
                      height={30}
                      Yes='Yes'
                      No='No'
                    />
                  </div>
                </div>
              </div>*/}
              
              <div className="inputs" style={{ marginRight: 20 }}>
                <div className="input">
                  <div className='d-flex flex-col w-100 mr-3' style={{ alignItems: "center", flexDirection: "row" }}>
                    <span>{t('menu.genai.minimumPassingScore')}:</span>
                    <img id="min-score" src="/icons/tooltip-indicator-icon.svg" className="ml-1 cursor-pointer tooltip-nesting" alt="" />
                    <Tooltip openOnClick={true} anchorSelect="#min-score" 
                      html={t('menu.genai.minimumPassingScoreTooltip')} place="top" />
                    <input
                      ref={minimum_passing_score_ref}
                      defaultValue={70}
                      type="number"
                      min="1"
                      max="100"
                      className="input-text input-data ml-2"
                      style={{maxWidth: 90}}
                    />
                  </div>
                </div>
              </div>
            </div>

            

          </div>

          



          <div id="motor">
            {/*<div className="input">*/}
            {/*  <span>Motor:</span>*/}
            {/*  <div className="motor">*/}
            {/*    <input*/}
            {/*      {...register('motor', { required: true })}*/}
            {/*      type="radio"*/}
            {/*      id="motor_1"*/}
            {/*      value="1"*/}
            {/*    />*/}
            {/*    <label htmlFor="motor_1">*/}
            {/*      <span>Motor 1</span>*/}
            {/*    </label>*/}
            {/*    <input {...register('motor')} type="radio" id="motor_2" value="2" />*/}
            {/*    <label htmlFor="motor_2">*/}
            {/*      <span>Motor 2</span>*/}
            {/*    </label>*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>

          {/*<div className="inputs" id="metadata">*/}
          {/*  <div className="flex items-center justify-end">*/}
          {/*    <div className="upload-excel trans">*/}
          {/*      <img src="/icons/excel.svg" alt="newAns" /><label> {t('menu.uploadExcel')}</label>*/}
          {/*      <input type='file' accept='.xlsx, .xls' onChange={prepareExcel} />*/}
          {/*    </div>*/}
          {/*    <div className="input">*/}
          {/*      <a className="a-download trans" href={"/excel/FormatProjects.xlsx"} download >Download Template</a>*/}
          {/*    </div>*/}
          {/*    <div className="input">*/}
          {/*      <div onClick={() => { uploadMaxive() }} className="a-download upload-btn trans"   >*/}
          {/*        <div className='btn-loanding'>*/}
          {/*          {loadingUpload ? <Loading /> : <div>Upload Projects</div>}*/}
          {/*        </div>*/}

          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </div>*/}
          {/*</div>*/}
          <div className="footer" style={{ marginTop: 30 }}>
            <div className='cont-buttons'>
              {errors.name?.type === 'required' ||
                errors.motor?.type === 'required' ||
                errors.metadata?.type === 'required' ? (
                <span style={{ color: "red" }}>{t('menu.fieldsRequired')}</span>
              ) : (
                <span> </span>
              )}
              <span className='errors-msg'  >{error.name}</span>
            </div>



          </div>
        </div>
        <div className='cont-buttons' style={{
          paddingRight: 20,
          width: '100%',
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          paddingTop: 12
        }}>
          <div className="buttons flex items-center" style={{ marginBottom: 20, }}>
            <button className="cancel btn-bottom btn-bottom-cancel" type="button" style={{ marginRight: 10, }} onClick={() => onClose()}>
              {t('common.cancel')}
            </button>
            <button className="create btn-bottom btn-bottom-create" type="submit" >
              {t('common.create')}
            </button>
          </div>
        </div>
      </form>
    </div>

  )
}
